module.exports = __webpack_public_path__ + "assets/a27a6829ee7bd0c494dcc71c78994233.png";